import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { Pencil, Loader2 } from "lucide-react";

const PAGE_GROUPS = [
  {
    label: "Main",
    items: [
      { key: "home", name: "Home", route: "/", customRoute: "/admin/home" },
      { key: "about", name: "About Finca Cortesín", route: "/about" },
      { key: "contact", name: "Contact", route: "/contact" },
    ],
  },
  {
    label: "Explore",
    items: [
      { key: "explore-hotel", name: "The Hotel", route: "/explore/hotel" },
      { key: "explore-restaurants", name: "Restaurants", route: "/explore/restaurants" },
      { key: "explore-beach-club", name: "Beach Club", route: "/explore/beach-club" },
      { key: "explore-spa", name: "The Spa", route: "/explore/spa" },
      { key: "explore-golf-course", name: "The Golf Course", route: "/explore/golf-course" },
    ],
  },
  {
    label: "Curated Collections",
    items: [
      { key: "category-frontline-golf", name: "Frontline Golf", route: "/categories/frontline-golf" },
      { key: "category-sea-view", name: "Sea View", route: "/categories/sea-view" },
    ],
  },
  {
    label: "Site Settings",
    items: [
      { key: "header", name: "Header & Navigation", route: "All pages", customRoute: "/admin/header" },
      { key: "footer", name: "Footer", route: "All pages", customRoute: "/admin/footer" },
      { key: "seo", name: "SEO & Sitemap", route: "Site-wide", customRoute: "/admin/seo" },
      { key: "settings", name: "Brochure PDF & Email Settings", route: "—", customRoute: "/admin/settings" },
    ],
  },
];

export default function AdminPagesList() {
  const [pages, setPages] = useState(null);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/admin/pages");
      const byKey = {};
      for (const p of data) byKey[p.key] = p;
      setPages(byKey);
    })();
  }, []);

  return (
    <div className="p-10 lg:p-16" data-testid="admin-pages-list">
      <p className="text-[10px] tracking-[0.3em] uppercase text-[#73706B] mb-3">
        — Manage
      </p>
      <h1
        className="text-5xl font-light mb-12"
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
      >
        Site Pages
      </h1>

      {pages === null ? (
        <Loader2 className="w-6 h-6 animate-spin text-[#C5A880]" strokeWidth={1.5} />
      ) : (
        <div className="space-y-10">
          {PAGE_GROUPS.map((g) => (
            <div key={g.label}>
              <p className="text-[10px] tracking-[0.3em] uppercase text-[#C5A880] mb-4">
                {g.label}
              </p>
              <div className="border border-[#E5DFD5] bg-[#FFFFFF]">
                {g.items.map((item) => {
                  const exists = pages[item.key];
                  return (
                    <Link
                      key={item.key}
                      to={item.customRoute || `/admin/pages/${item.key}`}
                      data-testid={`admin-page-${item.key}`}
                      className="flex items-center justify-between px-6 py-5 border-b border-[#E5DFD5] last:border-b-0 hover:bg-[#F9F6F0]"
                    >
                      <div>
                        <p
                          className="text-xl font-light text-[#1A1A1A]"
                          style={{ fontFamily: "'Cormorant Garamond', serif" }}
                        >
                          {item.name}
                        </p>
                        <p className="text-xs text-[#73706B] mt-1">
                          {item.route} {exists ? "" : "· not yet customised"}
                        </p>
                      </div>
                      <Pencil className="w-4 h-4 text-[#73706B]" strokeWidth={1.5} />
                    </Link>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
